/**
 * Get IPFS URL using the configured gateway
 * @param {string} cid - The IPFS CID
 * @param {string} [path] - Optional path within the IPFS directory
 * @returns {string} Full IPFS gateway URL
 */
export const getIpfsUrl = (cid, path) => {
  const gateway = process.env.REACT_APP_IPFS_GATEWAY || "https://ipfs.io/ipfs/";
  return `${gateway}${cid}${path ? '/' + path : ''}`;
};
